// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"jut__Tooltip__tooltip"};